import { partial } from "lodash";
import React, { type FC } from "react";

import { type AddPeopleToContentTypes, Strings } from "../../../enums";
import { EllipsisPopup, type EllipsisPopupOption } from "../../buttons/ellipsisPopup/EllipsisPopup";
import { getAddContentEllipsisPopupOptions } from "../addContentButtonEllipsisOptions/AddContentButtonEllipsisOptions";
import { FeatureFlags } from "../../../featureFlags";
import { useFeatureFlag } from "../../../hooks/useFeatureFlag";

export interface Props {
  disabled: boolean;
  user: any;
  goToEditUser: (id: number) => void;
  onAddToContent: (id: number, contentType: AddPeopleToContentTypes) => void;
  onAddToGroup: (id: number) => void;
  onAddToRole: (id: number) => void;
  onAddToBlackList: (ids: number[]) => void;
  onRemoveFromBlackList: (ids: number[]) => void;
  onDeleteUser: (id: number) => void;
}

const UserEllipsisPopupButton: FC<Props> = ({
  user,
  goToEditUser,
  onAddToContent,
  onAddToGroup,
  onAddToRole,
  onAddToBlackList,
  onRemoveFromBlackList,
  onDeleteUser,
  disabled,
}) => {
  const blackListEnabled = useFeatureFlag(FeatureFlags.BlackList);
  const getBlacklistOption = (userId: number, isBlackList: boolean): EllipsisPopupOption => ({
    label: "No Contact List",
    iconName: isBlackList ? "far fa-minus-circle" : "far fa-plus-circle",
    onClick: () => (isBlackList ? onRemoveFromBlackList([userId]) : onAddToBlackList([userId])),
  });

  const commonPlusIcon = "far fa-plus-circle";

  const contentOptions: EllipsisPopupOption[] = [
    { label: "Edit", iconName: "fa-edit", onClick: () => goToEditUser(user.id) },
    {
      label: Strings.modalTitles.addContent,
      iconName: commonPlusIcon,
      options: getAddContentEllipsisPopupOptions(partial(onAddToContent, user.id)),
    },
    { label: "Add To Group", iconName: commonPlusIcon, onClick: () => onAddToGroup(user.id) },
    { label: "Add To Role", iconName: commonPlusIcon, onClick: () => onAddToRole(user.id) },
    { label: "Delete", iconName: "fa-trash-alt", onClick: () => onDeleteUser(user.id) },
  ];

  if (blackListEnabled) {
    contentOptions.splice(4, 0, getBlacklistOption(user.id, user.isBlackList));
  }

  return <EllipsisPopup options={contentOptions} disabled={disabled} />;
};

export default UserEllipsisPopupButton;
